<template>
    <settings-control label="Border Width" expand>
        <slider
            :value="sliderIndex"
            :values="borderWidthValues"
            hide-marks
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';
import { tailwindThemePropSort } from '@/utils/tailwind-helper';

const configValues = tailwindConfig.theme.borderWidth;

export default {
    name: 'settings-control-border-width',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            borderWidthValues: Object.values(configValues)
                .sort(tailwindThemePropSort),
            sliderIndex: 0,
        };
    },

    watch: {
        value: {
            handler(newVal) {
                this.sliderIndex = this.borderWidthValues.indexOf(newVal);
            },
            immediate: true,
        },
    },

    methods: {
        onInput(index) {
            this.$emit('input', {
                tailwindDefinitionProp: 'borderWidth',
                value: this.borderWidthValues[index],
            });
        },
    },
};
</script>
